import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { AttractionFormDataType } from "@/pages/CreateAttraction"
import { useQueryClient } from "@tanstack/react-query"
import queryKeys from "@/api/queryKeys"

function useCreateAttraction() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: AttractionFormDataType) =>
      client.post(`/attractions`, data).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.attractions.list({}).queryKey,
      })
    },
  })
}
export default useCreateAttraction
